module.exports = __webpack_public_path__ + "static/media/menu-dots.5d9b7827.svg";